<template>
    <div :class="{'warning-icon':(!isMyUserAdmin)}" />
    <DxTabPanel 
        :items="screenList"
        :animation-enabled="false" 
        :swipe-enabled="false"
        @selection-changed="screenChanged"
        v-model:selected-index="selectedScreen">
    </DxTabPanel>

    <!-- SYSTEM -->

    <div class="row mt-4" v-if="(selectedScreen==0)" :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}">
        <div class= "col">
            <h3 class="row-12 mb-3" > Current System Date: {{ CurrentHour }} </h3> 
            <p> Region: {{ systemData_state.region }} // Language: {{ languages.find(l => l.value==systemData_state.language)?.name }}</p>
            
        </div>
        <div class= "col-7 col-md-4">
            <DxButton
            text="Apply changes"
            type="success"
            width="50%"
            @click="savesystemChanges"
            />  
            <DxButton
            text="Restart options"
            type="normal"
            width="50%"
            @click="rebootPanel = true"
            /> 
        </div>
        
        <h3 class="row-12 mb-3 mt-3" > Change system info </h3>
        <DxForm ref="form_system" :form-data="systemData"  label-location="left" :min-col-width="350">
            <DxGroupItem :col-count=3 :min-col-width="350"  caption="Date">      
            <DxSimpleItem 
                data-field="region" 
                editor-type="dxSelectBox"
                :editor-options="{ dataSource: timeZones, valueExpr:'value', displayExpr:'value'}" 
            />
            <DxSimpleItem 
                data-field="date" 
                editor-type="dxDateBox"
                :editor-options="{ acceptCustomValue:false, type:'datetime',maxLength: 300}" 
            />
            <!---
            <DxSimpleItem 
                data-field="date" 
                editor-type="dxDateBox"
                :editor-options="{  type:'date',maxLength: 300 }" 
            />
            <DxSimpleItem 
                data-field="hour" 
                editor-type="dxDateBox"
                :editor-options="{  type:'time',maxLength: 300 }" 
            />-->
            </DxGroupItem>
            <DxGroupItem :col-count=3 :min-col-width="350" caption="language">      
                <DxSimpleItem 
                    data-field="language" 
                    editor-type="dxSelectBox"
                    :editor-options="{ dataSource: languages, valueExpr:'value', displayExpr:'name'}" 
                />
            </DxGroupItem>
        </DxForm>
            
    </div>
  
    <!-- WIFI -->

    <div class="row mt-4" v-if="(selectedScreen==1)" :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}">
        <div class= "col">
            <h3 class="row-12 mb-3" > Current State: {{ netStateList.find(st => (st.id==netData_state.id_current_state)).state_name }} </h3> 

            <p> Mode: {{ modeNetData[modeNetSelected_state].name }} </p>
            <p v-if="(modeNetSelected_state==1)"> SSID: {{ netData_state.ap_ssid }} </p>
            <p v-if="(modeNetSelected_state==2)"> SSID: {{ netData_state.cl_ssid }} </p>
        </div>
        <div class= "col-7 col-md-4">
            <DxButton
            text="Apply changes"
            type="success"
            width="50%"
            @click="showPopupNetwork"
            validation-group="validationGroup_wifi"
            />  
            <DxButton
            text="Restart options"
            type="normal"
            width="50%"
            @click="rebootPanel = true"
            /> 
        </div>
       
        <!-- <h3 class="row-12 mb-3 mt-3" > Change Wifi Configuration </h3> -->
        <div class="row-12 mb-3 mt-1" > </div>
        <div class="col-4">
            <h4> Mode </h4>
            <div class="radiobutton-mod">
                <DxRadioGroup
                style=" "
                :items="modeNetData"
                value-expr="value"
                display-expr="name"
                v-model:value="modeNetSelected"
                v-model:onValueChanged="modeChanged"
                layout="vertical"
               
                />
            </div>
            
        </div>
        
        <div class="col" v-if="modeNetSelected==0"> 
        <h4> Disconnected </h4>
        </div>

        <div class="col" v-if="modeNetSelected==1"> 
        <DxForm :form-data="netData"  label-location="left" :min-col-width="350" validation-group="validationGroup_wifi">
            <DxGroupItem  :col-count=2 :min-col-width="350" caption='Access Point Mode'>      
            <DxSimpleItem 
                data-field="ap_ssid" 
                editor-type="dxTextBox"
                :editor-options="{ maxLength: 300, disabled: true }" 
            />
            <DxSimpleItem 
                data-field="ap_router_ip" 
                editor-type="dxTextBox"
                :editor-options="{ maxLength: 300, disabled: true  }" 
            />
            <DxSimpleItem 
                data-field="ap_password"
                editor-type="dxTextBox"
                :editor-options="{ maxLength: 300, placeholder: 'password', mode: passwordMode}" 
                >
                <DxRequiredRule message="password is required to login" />
            </DxSimpleItem>

            <DxSimpleItem 
                data-field="showPass"
                :label="{text:'show password'}"
                editor-type="dxCheckBox"
                :editor-options="{disabled:!isMyUserAdmin, onValueChanged: showPass}"/>

            <DxSimpleItem 
                data-field="ap_sec_protocol" 
                editor-type="dxTextBox"
                :editor-options="{ maxLength: 300, disabled: true  }" 
            />
            
            </DxGroupItem>
        </DxForm>
        </div>

        <div class="col" v-if="modeNetSelected==2" > 
        <DxForm :form-data="netData"  label-location="left" :min-col-width="350" validation-group="validationGroup_wifi">
            <DxGroupItem  :col-count=2 :min-col-width="350" caption='WIFI Client Mode'>  
  
            <DxSimpleItem 
                data-field="cl_ssid" 
                editor-type="dxSelectBox"
                :editor-options="{ dataSource: wifiList, valueExpr:'value', displayExpr:'value'}" 
            />
            <DxButtonItem
                    :button-options="{onClick:wifiList_reload, icon:'refresh' ,text: 'Refresh'}"
                    horizontal-alignment="left"
                />
            <DxSimpleItem 
                data-field="cl_password" 
                editor-type="dxTextBox"
                :editor-options="{ maxLength: 300,  placeholder: 'password', mode: passwordMode }">
                <DxRequiredRule message="password is required to login" />        
            </DxSimpleItem>
            <DxSimpleItem
                data-field="showPass" 
                :label="{text:'show password'}"
                editor-type="dxCheckBox"
                :editor-options="{disabled:!isMyUserAdmin,onValueChanged: showPass}"/>

            <DxSimpleItem 
                data-field="cl_sec_protocol" 
                editor-type="dxTextBox"
                :editor-options="{ maxLength: 300, disabled: true   }" 
            />
            </DxGroupItem>
        </DxForm>
        </div>

   </div>

    <!-- ETHERNET -->
    <div class="row mt-4" v-if="(selectedScreen==2)" :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}">

        <div class= "col">
             <h3 class="row-12 mb-3" > Current State: {{  netStateList.find(st => (st.id==ethData_state.id_current_state)).state_name  }} </h3> <!--{{  netStateList.find(st => (st.id==ethData_state.id_current_state)).state_name  }} -->
            
            <p> Mode: {{ modeEthData[modeEthSelected_state].name }} // Interface: {{ ethData_state.interface_name }} </p>   
            <p > IP: {{ ethData_state.ip_addr_v4 }}  //  Mask: {{ ethData_state.netmask }}  //  Gateway:   {{ ethData_state.gateway_addr_v4 }} </p>
            <p v-if="(ethData_state.dns1!='') && (ethData_state.dns2!='')"> DNS1: {{ ethData_state.dns1 }} // DNS2: {{ ethData_state.dns2 }} </p>
            <p v-if="(ethData_state.dns1=='') && (ethData_state.dns2!='')"> DNS2: {{ ethData_state.dns2 }} </p>
            <p v-if="(ethData_state.dns1!='') && (ethData_state.dns2=='')"> DNS1: {{ ethData_state.dns1 }} </p>
        
              
        </div>
        <div class= "col-7 col-md-4">
            <DxButton
            text="Apply changes"
            type="success"
            width="50%"
            validation-group="validationGroup_eth"
            @click="showPopupEther"
            />  
            <DxButton
            text="Restart options"
            type="normal"
            width="50%"
            @click="rebootPanel = true"
            /> 
        </div>
        
        <div class="row-12 mb-3 mt-1" > </div>
        <div class="col-4">
            <h4> Mode </h4>
            <div class="radiobutton-mod">
                <DxRadioGroup
                style=" "
                :items="modeEthData"
                value-expr="value"
                display-expr="name"
                v-model:value="modeEthSelected"
                v-model:onValueChanged="modeEthChanged"
                layout="vertical"
                />
            </div>
            
        </div>
        <div class="col" v-if="modeEthSelected==0"> 
            <DxForm :form-data="ethData"  label-location="left" :min-col-width="350" validation-group="validationGroup_eth">
                <DxGroupItem  :col-count=2 :min-col-width="350" caption='Mode Manual IP '>      
                <DxSimpleItem 
                    data-field="interface_name" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: true }" 
                />
               <DxSimpleItem 
                    data-field="gateway_addr_v4" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: false  }" 
                >
                    <DxPatternRule 
                        :pattern="/^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/"
                        message="The IP must have a correct format"
                    />
                </DxSimpleItem>
                <DxSimpleItem 
                    data-field="ip_addr_v4"
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: false }" 
                    >
                    <DxPatternRule 
                        :pattern="/^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/"
                        message="The IP must have a correct format"
                    />
                </DxSimpleItem>

                <DxSimpleItem 
                    data-field="netmask"
                    editor-type="dxTextBox"
                    :editor-options="{maxLength: 300, disabled: false }">
                 <DxPatternRule 
                        :pattern="/^(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/"
                        message="The Netmask must have a correct format"
                    />
                </DxSimpleItem>

                <DxSimpleItem 
                    data-field="dns1" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: false  }" 
                />
                <DxSimpleItem 
                    data-field="dns2" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: false  }" 
                />
                
                </DxGroupItem>
            </DxForm>
        </div>
        <div class="col" v-if="modeEthSelected==1"> 
            <DxForm :form-data="ethData"  label-location="left" :min-col-width="350" validation-group="validationGroup_eth">
                <DxGroupItem  :col-count=2 :min-col-width="350" caption="Mode DHCP">      
                <DxSimpleItem 
                    data-field="interface_name" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: true }" 
                />
                <DxSimpleItem 
                    data-field="gateway_addr_v4" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: true  }" 
                />
                <DxSimpleItem 
                    data-field="ip_addr_v4"
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: true }" 
                    >
                </DxSimpleItem>

                <DxSimpleItem 
                    data-field="netmask"
                    editor-type="dxTextBox"
                    :editor-options="{maxLength: 300, disabled: true }"/>

                
                <DxSimpleItem 
                    data-field="dns1" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: true  }" 
                />
                <DxSimpleItem 
                    data-field="dns2" 
                    editor-type="dxTextBox"
                    :editor-options="{ maxLength: 300, disabled: true  }" 
                />
                
                </DxGroupItem>
            </DxForm>

            
        </div>
        
    </div>
    <DxPopup
        content-template="apply-changes"
        :show-title="false"
        max-width="300px"
        max-height="120px"
        v-model:visible="isChangedNetworkVisible"
        :hide-on-outside-click="true">
        <template #apply-changes>
            <p style="centering">The connection to the Webapp will be lost when changing the Network configuration.</p>
            <div class="row">
            <div class="col">
            <DxButton
            text="Apply changes"
            type="success"
            width="100%"
            @click="saveNetworkChanges"
            /> 
            </div> 
            <div class="col">
             <DxButton
            text="Cancel"
            type="danger"
            width="100%"
            @click="cancelNetworkChanges"
            />  
            </div>
            </div>
        </template>            
    </DxPopup>

    <DxPopup
        content-template="apply-changes"
        :show-title="false"
        max-width="300px"
        max-height="120px"
        v-model:visible="isChangedEtherVisible"
        :hide-on-outside-click="true">
        <template #apply-changes>
            <p style="centering">The connection to the Webapp will be lost when changing the Network configuration.</p>
            <div class="row">
            <div class="col">
            <DxButton
            text="Apply changes"
            type="success"
            width="100%"
            @click="saveEtherChanges"
            /> 
            </div> 
            <div class="col">
             <DxButton
            text="Cancel"
            type="danger"
            width="100%"
            @click="cancelEtherChanges"
            />  
            </div>
            </div>
        </template>            
    </DxPopup>

    <DxPopup
        content-template="reboot"
        :show-title="false"
        max-width="300px"
        max-height="200px"
        v-model:visible="rebootPanel"
        :hide-on-outside-click="true">
        <template #reboot>
            <p style="centering">Select the components to be restarted</p>
            <div class="mt-1"><DxCheckBox text="EMS"  v-model:value="selectedRebootOptions[0]"/></div>
            <div class="mt-1"><DxCheckBox text="COMMS" v-model:value="selectedRebootOptions[1]" /></div>
            <div class="mt-1"><DxCheckBox text="Webapp"  v-model:value="selectedRebootOptions[2]" /></div>
            <div class="mt-1 mb-3"><DxCheckBox text="Enfyo"  v-model:value="selectedRebootOptions[3]" /></div>

            <div clase="row">
                <DxButton
                    text="Restart"
                    type="success"
                    width="50%"
                    @click="sendReboot()"
                    /> 
                <DxButton
                    text="Cancel"
                    type="danger"
                    width="50%"
                    @click="()=>rebootPanel=false"
                    />   
            </div>
            
        </template>            
    </DxPopup>

</template>

<script>
import {reactive, ref,onUnmounted, watch } from 'vue';
import { useStore } from 'vuex';
import DxTabPanel from 'devextreme-vue/tab-panel';
import DxCheckBox from 'devextreme-vue/check-box';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxButtonItem,
  DxPatternRule 
} from 'devextreme-vue/form';
import DxButton from 'devextreme-vue/button';
import {
  DxRequiredRule,
} from 'devextreme-vue/validator';
import DxRadioGroup from 'devextreme-vue/radio-group';
import notify from 'devextreme/ui/notify';
import RawDataService from '../services/RawDataServiceTemplate';
import {timezones} from '../services/timezones_enfyoOSv4.js';
import { DxPopup } from 'devextreme-vue/popup';
import appInfo from "../app-info";

export default ({
    data(){
        return {
            screenList: [
                { ctrId: 'TIME & LANGUAGE', title:'Time & Language' },
                { ctrId: 'WIFI', title: 'Wifi' },
                { ctrId: 'ETHERNET', title: 'Ethernet' },
                ],
            timeZones: timezones,
            modeNetData : ref([
                { name: 'Disconnected', value: 0}, 
                { name: 'Access_point', value: 1}, 
                { name: 'Wifi_client', value: 2}
                ]),
            passwordMode: 'password',
            showPass: ()=>{
                this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
            },
            modeEthData : ref([
                { name: 'Manual IP', value: 0}, 
                { name: 'DHCP', value: 1}, 
                ]),
        }
    },
    components: {
        DxTabPanel,
        DxForm,
        DxSimpleItem,
        DxGroupItem,
        DxRequiredRule,
        DxRadioGroup,
        DxButton,
        DxButtonItem,
        DxPatternRule,
        DxPopup,
        DxCheckBox
    },
    setup() {
        // Validate permissions
        const store = useStore()
        const DEF_AUTHCODES = { web:1, admon:190, iot:120 };
        const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)
        //

        const stErrorCb = err => { notify(err.message, "error", 3000); }

        const selectedScreen = ref(0);
        const screenChanged = () =>{};


        // HOUR
        const CurrentHour= ref('');
        const timer1 = setInterval(updateTime, 1000);
        updateTime();
        function updateTime() {
            CurrentHour.value = new Date().toUTCString()
           
        }
       
        //SYSTEM    
        const form_system = ref(null)
        const systemDataService = new RawDataService('system/info');
        const languages= [
            {value: 1, name: "English"},
            {value: 2, name: "Spanish"},
        ];

        const systemData= reactive({ 
            region: null,
            date: new Date(), //////////////// integrate db
            language: 1
        });

        const systemData_state= reactive({ 
            region: null,
            date: new Date(), //////////////// integrate db
            hour: null,
            language: null,
        });
        
        
        const savesystemChanges = async () => {   

           const saveData={
                timezone:systemData.region,
                user_language:systemData.language,
                date:Math.floor(systemData.date.getTime() / 1000)
           }
            try{
                const response = await systemDataService.update('',saveData)
                if(response.isOk){
                   notify(response.message||"network settings updated", "success", 3500)
                   await store.dispatch('setTimezone',saveData.timezone)
                   loadNet();

                }else{
                    notify(response.message||"unexpected response", "warn", 3500)
                }

            }catch(error){
                stErrorCb(error);
            }
        }

        /*const selecC =()=>{
            console.log ((systemData.date.getMonth()+1)+"/"+(systemData.date.getDate())+"/"+systemData.date.getFullYear())
            console.log (systemData.hour.getHours()+":"+systemData.hour.getMinutes())
        }*/
        
        // NETWORKS

        let modeNetSelected=ref(0);
        let modeNetSelected_state=ref(0);

        const netState = ref(5);
        const netStateList= reactive([]);

        const wifiDataService = new RawDataService('wifi/config');
        const wifiStateDataService = new RawDataService('wifi/state');
        const wifiScansDataService = new RawDataService('wifi/scans');
        const wifiNetStateDataService = new RawDataService('wifi/netstates');

        const netData = reactive({ 
            ap_ssid:"",
            ap_password: "",
            ap_sec_protocol: "",
            ap_router_ip: "",
            cl_ssid: "",
            cl_password: "",
            cl_sec_protocol:"",
            enabled: 1,
            using_ap: 1,
            showPass:false,
        });
       
        const netData_state = reactive({ 
            ap_ssid:"",
            cl_ssid: "",
            enabled: 1,
            using_ap: 1,
            id_current_state:0,
        });
        
        const wifiList = ref([]);
        const wifiList_reload = async() => {
            try{
            wifiList.value =[];
            const scanList= await wifiScansDataService.getAll();
            let id=0;
            let newScans =[];
            for(const scan of scanList){
                newScans.push({
                id:id, 
                value: scan.ssid
                });     
                id++;  
            }
            wifiList.value=newScans;
              
            }catch(err) { notify('error: '+err.message, 'error', 4000); }
        } 
        const isChangedNetworkVisible = ref(false);
        const showPopupNetwork = (e) =>{
            if(e.validationGroup.validate().isValid)
                isChangedNetworkVisible.value = true;
        }
        const cancelNetworkChanges = () =>{
            isChangedNetworkVisible.value = false;
        }

        let intervalId;
        let timeOutId;
        const saveNetworkChanges = async () =>{ 
            const saveData = netData;
            isChangedNetworkVisible.value = false;
            try{
                const response = await wifiDataService.update('',saveData)
                if(response.isOk){
                    notify("Pending change", "error", 2000)
                    clearInterval(intervalId);
                    clearTimeout(timeOutId);
                    intervalId = setInterval(function(){
                        wifiStateDataService.getAll().then(res => {
                            Object.assign(netData_state, res[0]);
                        }).catch(error=>{
                            if(error.code=='ERR_NETWORK'){
                                clearInterval(intervalId);
                                clearTimeout(timeOutId);
                                notify("The connection has been lost. The site will reload automatically.", "error", 4000)
                                setTimeout(function(){
                                    location.reload(    );
                                }, 4000); 
                            }else
                                stErrorCb(error)
                        });
                        
                        if (netData_state.id_current_state==5 ){
                            notify("network settings updated", "success", 2000)
                            wifiStateDataService.update('',{id_current_state:1})
                            loadNet();
                            clearInterval(intervalId);
                        }else if (netData_state.id_current_state==3 || netData_state.id_current_state==4){
                            notify("error in settings updated", "error", 2000)
                            wifiStateDataService.update('',{id_current_state:1})
                            loadNet();
                            clearInterval(intervalId);
                        } else {
                            notify("Pending change", "error", 2000)
                        }
                    },3000)

                    timeOutId = setTimeout(function(){
                        clearInterval(intervalId);
                    }, 20000); 

                }else{
                    notify(response.message||"unexpected response", "warn", 3500)
                }

            }catch(error){
                stErrorCb(error);
            }
        }

        const modeChanged = ()=>{
            if (modeNetSelected.value==0){
                netData.enabled=0;
            }else if(modeNetSelected.value==1){
                netData.enabled=1;
                netData.using_ap=1;
            }else{
                netData.enabled=1;
                netData.using_ap=0;
            }
        }

        // ETHERNET 
        
        let modeEthSelected=ref(0);
        let modeEthSelected_state=ref(0);
        const ethDataService = new RawDataService('ethernet/config');
        const ethStateDataService = new RawDataService('ethernet/state'); 

        const ethData = reactive({ 
            interface_name:"",
            using_dhcp: true,
            ip_addr_v4: "",
            netmask: "",
            gateway_addr_v4: "",
            dns1: "",
            dns2:"",
        });
       
        const ethData_state = reactive({ 
            interface_name:"",
            using_dhcp: true,
            ip_addr_v4: "",
            netmask: "",
            gateway_addr_v4: "",
            dns1: "",
            dns2:"",
            id_current_state: 0,
        });

        const isChangedEtherVisible = ref(false);
        const showPopupEther = (e) =>{
            if(e.validationGroup.validate().isValid)
                isChangedEtherVisible.value = true;
        }
        const cancelEtherChanges = () =>{
            isChangedEtherVisible.value = false;
        }


        let intervalId_eth;
        let timeOutId_eth;
        const saveEtherChanges = async () =>{
            const saveData = ethData;
            isChangedEtherVisible.value = false;
            try{
                const response = await ethDataService.update('',saveData)
                if(response.isOk){
                    notify("Pending change", "error", 2000)
                    clearInterval(intervalId_eth);
                    clearTimeout(timeOutId_eth);
                    intervalId_eth = setInterval(function(){
                        ethStateDataService.getAll().then(res => {
                            Object.assign(ethData_state, res[0]);
                        }).catch(error=>{
                            if(error.code=='ERR_NETWORK'){
                                clearInterval(intervalId_eth);
                                clearTimeout(timeOutId_eth);
                                notify("The connection has been lost. The site will reload automatically.", "error", 4000)
                                setTimeout(function(){
                                    location.href =`${appInfo.serverProtocol}//${saveData.ip_addr_v4}:${appInfo.serverPort}`;
                                }, 4000); 
                            }else
                                stErrorCb(error)
                        });

                        if (ethData_state.id_current_state==5 ){
                            notify("ethernet settings updated", "success", 2000)
                            ethStateDataService.update('',{id_current_state:1})
                            loadNet();
                            clearInterval(intervalId_eth);
                        }else if (ethData_state.id_current_state==3 || ethData_state.id_current_state==4){
                            notify("error in settings updated", "error", 2000)
                            ethStateDataService.update('',{id_current_state:1})
                            loadNet();
                            clearInterval(intervalId_eth);
                        } else {
                            notify("Pending change", "error", 2000)
                        }
                    },3000);

                    timeOutId_eth = setTimeout(function(){
                        console.log('fin temporizador')
                        clearInterval(intervalId_eth);
                    }, 20000); 

                }else{
                    notify(response.message||"unexpected response", "error", 3500)
                }

            }catch(error){
                stErrorCb(error);
            }
        }
        
        const modeEthChanged = ()=>{
            if (modeEthSelected.value==0){
                ethData.using_dhcp=0;
            }else{
                ethData.using_dhcp=1;
            }
        }

        ////// LOAD PAGE

        const loadNet = async () => {
            // system
            
           systemDataService.getAll().then(res => {
                systemData_state.region=res[0].timezone;
                systemData.region=res[0].timezone;
                systemData_state.language=res[0].user_language;
                systemData.language=res[0].user_language;

            }).catch(stErrorCb);

            // Wifi
            wifiDataService.getAll().then(res => {
                Object.assign(netData, res[0]);
                wifiList_reload();

                if (netData.enabled==0){
                    modeNetSelected.value=0;
                }else{
                    if(netData.using_ap==1){
                        modeNetSelected.value=1;
                    }else{
                        modeNetSelected.value=2;
                    }
                }
            }).catch(stErrorCb);
           
           wifiStateDataService.getAll().then(res => {
                Object.assign(netData_state, res[0]);
                if (netData_state.enabled==0){
                    modeNetSelected_state.value=0;
                }else{
                    if(netData_state.using_ap==1){
                        modeNetSelected_state.value=1;
                    }else{
                        modeNetSelected_state.value=2;
                    }
                }
            }).catch(stErrorCb);

            wifiNetStateDataService.getAll().then(res => {
                Object.assign(netStateList, res);
            })


            // Etherent

            ethDataService.getAll().then(res => {
                Object.assign(ethData, res[0]);
                if (ethData.using_dhcp==0){
                    modeEthSelected.value=0;
                }else{
                    modeEthSelected.value=1;
                }
            }).catch(stErrorCb);
           
           ethStateDataService.getAll().then(res => {
                Object.assign(ethData_state, res[0]);
                 if (ethData.using_dhcp==0){
                    modeEthSelected_state.value=0;
                }else{
                    modeEthSelected_state.value=1;
                }
            }).catch(stErrorCb);

           
        }

        loadNet();

        const rebootPanel = ref(false)
        const selectedRebootOptions = ref ([false,false,false,false])
        let selectedRebootOptions_pre = [false,false,false,false]
        
        watch(selectedRebootOptions,changeRebootOptions, { deep: true })

        function changeRebootOptions(){
            if(selectedRebootOptions.value[3] && !selectedRebootOptions_pre[3]){
                selectedRebootOptions.value = [true,true,true,true]
            }else if(selectedRebootOptions.value[3] && selectedRebootOptions_pre[3] && JSON.stringify(selectedRebootOptions.value) !== JSON.stringify([true,true,true,true])){
                selectedRebootOptions.value[3] = false
            }else if(!selectedRebootOptions_pre[3] && JSON.stringify(selectedRebootOptions.value) == JSON.stringify([true,true,true,false])){
                selectedRebootOptions.value[3] = true
            }else if(!selectedRebootOptions.value[3] && selectedRebootOptions_pre[3]){
                selectedRebootOptions.value = [false,false,false,false]
            }

            selectedRebootOptions_pre = [...selectedRebootOptions.value]
        }

        const restartDataService = new RawDataService('masters/restart');
        function sendReboot(){
            const options = []
            if(selectedRebootOptions.value[0]) options.push('ems')
            if(selectedRebootOptions.value[1]) options.push('comms')
            if(selectedRebootOptions.value[2]) options.push('webapp')
            if(selectedRebootOptions.value[3]) options.push('enfyo')

            console.log(('restart: '+options))
            restartDataService.create(JSON.stringify(options))

            selectedRebootOptions.value=[false,false,false,false]
            rebootPanel.value =false
           

        }

        onUnmounted(()=>{
            clearInterval(timer1)
        })

        return {
            isMyUserAdmin,
            selectedScreen,
            CurrentHour,

            form_system,
            systemData,
            systemData_state,
            languages,
            savesystemChanges,

            modeNetSelected,
            modeNetSelected_state,
            netData,
            netData_state,
            wifiList,
            netState,
            netStateList,
            screenChanged,
            modeChanged,
            isChangedNetworkVisible,
            showPopupNetwork,
            saveNetworkChanges,
            wifiList_reload,

            ethData,
            ethData_state,
            modeEthSelected,
            modeEthSelected_state,
            saveEtherChanges,
            modeEthChanged,
            isChangedEtherVisible,
            showPopupEther,
            
            cancelNetworkChanges,
            cancelEtherChanges,
            rebootPanel,
            selectedRebootOptions,
            changeRebootOptions,
            sendReboot
        }
    },
})

</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.radiobutton-mod .dx-item-content{
  font-size: 1.3em;
  margin:0.5em;
}


</style>